import { render, staticRenderFns } from "./billRow.vue?vue&type=template&id=33d484b6&slot=bills&slot-scope=props&"
import script from "./billRow.vue?vue&type=script&lang=js&"
export * from "./billRow.vue?vue&type=script&lang=js&"
import style0 from "./billRow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "billRow.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCheckbox,
  VDialog,
  VDivider,
  VIcon,
  VList,
  VMenu,
})
